import { createClient } from 'react-fetching-library';
import _ from 'lodash';
import store from '../services/redux-store';

const requestHostInterceptor = host => client => action => ({
  ...action,
  endpoint: `${host}${action.endpoint}`
});

export const client = createClient({
  // eslint-disable-next-line no-undef
  requestInterceptors: [requestHostInterceptor(`${process.env.REACT_APP_API_URL}`)]
});

export const loginAction = body => ({
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  endpoint: 'auth/login/',
  body
});

export const registerAction = body => ({
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  endpoint: 'auth/register/',
  body
});

export const resetPasswordAction = body => ({
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  endpoint: 'auth/reset-password/',
  body
});

export const resetPasswordCompleteAction = body => ({
  method: 'PATCH',
  headers: {
    'Content-Type': 'application/json'
  },
  endpoint: 'auth/reset-password/',
  body
});

export const logoutAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`

    },
    credentials: 'include',
    endpoint: 'logout/',
    body
  };
};

export const changePasswordLoggedInUserAction = body => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'auth/reset-password/change_password_logged_in_user/',
    body
  };
};

export const generateReportAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'payments/generate_report/',
    body,
    responseType: 'blob'
  };
};

export const createTransactionAction = params => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `payments/create_url_for_transaction/?${params}`
  };
};

export const createJsonFormAction = (body, method = 'POST', id = null) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method,
    headers,
    endpoint: `json-forms/${id ? `${id}/` : ''}`,
    body
  };
};

export const createJsonFormNewVersionAction = (id, body) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'POST',
    headers,
    endpoint: `json-forms/${id}/create_new_version/`,
    body
  };
};

export const getJsonFormsAction = (id = null) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `json-forms/${id ? `${id}/` : ''}`
  };
};

export const getSurveysTemplatesAction = () => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: 'json-forms/get_surveys_templates/'
  };
};

export const getSurveysAction = id => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `json-forms/get_surveys/?id=${id}`
  };
};

export const getSurveysStatisticsAction = (id, dateFrom, dateTo) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `json-forms/get_surveys_statistics/?id=${id}${
      dateFrom ? `&dateFrom=${dateFrom}` : ''
    }${dateTo ? `&dateTo=${dateTo}` : ''}`
  };
};

export const getLatestJsonFormAction = (type, admin, version) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `json-forms/get_latest_form/?identifier=${type}${
      admin ? '&admin=true' : ''
    }${version ? `&version=${version}` : ''}`
  };
};

export const uploadFormSchemaAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'forms/upload_form_schema/',
    body
  };
};

export const getFormListAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'forms/get_latest_forms/'
  };
};

export const getLatestFormAction = (type, year = false) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `forms/get_latest_form/?form_type=${type}&year=${year}`
  };
};

export const getInitZSDataAction = params => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  const queryString = new URLSearchParams(params).toString();

  return {
    method: 'GET',
    headers,
    endpoint: `forms/get_init_zs_data/?${queryString}`
  };
};

export const getInitWRDataAction = (resort, period) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `forms/get_init_wr_data/?resort=${resort}&period=${period}`
  };
};

export const getFormSectionsAction = id => {
  const state = store.getState();
  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `forms/${id}/get_sections/`
  };
};

export const submitFormAction = (body, id, testForm = false) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }
  let endpoint = `forms/${id}/submit_form/`;
  if (testForm) {
    endpoint = `forms/${id}/test_submit_form/`;
  }

  return {
    method: 'POST',
    headers,
    endpoint,
    body
  };
};

export const submitJsonFormAction = (body, id) => {
  const state = store.getState();

  const headers = {};

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'POST',
    headers,
    endpoint: `json-forms/${id}/submit_form/`,
    body
  };
};

export const getDependsOnSeasonsAction = (identifier, params) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `seasons/${identifier}/get_depends_on_data/?${params}`
  };
};

export const getDependsOnPLSeasonsAction = (identifier, params) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `seasons/${identifier}/get_depends_on_pl_data/?${params}`
  };
};

export const getDependsOnResortAction = (identifier, params) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `seasons/${identifier}/get_depends_on_resort_data/?${params}`
  };
};

export const getDependsOnPeriodAction = (identifier, params, searchParams) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }
  const discountCode = searchParams.get('promotion_code');
  if (discountCode) {
    // eslint-disable-next-line no-param-reassign
    params += `&discount_code=${discountCode}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `seasons/${identifier}/get_depends_on_period_data/?${params}`
  };
};

export const getDependsOnPackageAction = (identifier, params, searchParams) => {
  const state = store.getState();
  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }
  const discountCode = searchParams.get('promotion_code');
  if (discountCode) {
    // eslint-disable-next-line no-param-reassign
    params += `&discount_code=${discountCode}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `seasons/${identifier}/get_depends_on_package_data/?${params}`
  };
};

export const getDependsOnVoivodeshipAction = (identifier, params) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `seasons/${identifier}/get_depends_on_voivodeship_data/?${params}`
  };
};

export const getDependsOnCountyAction = (identifier, params) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `seasons/${identifier}/get_depends_on_county_data/?${params}`
  };
};

export const getDependsOnCommuneAction = (identifier, params) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `seasons/${identifier}/get_depends_on_commune_data/?${params}`
  };
};

export const getDependsOnCityAction = (identifier, params) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `seasons/${identifier}/get_depends_on_city_data/?${params}`
  };
};

export const getSeasonInitData = identifier => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `seasons/${identifier}/get_season_init_data/`
  };
};

export const getSeasonsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `search=${val}&`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `seasons/?module=${state.app.module || null}${search}`
  };
};

export const submitSeasonAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `seasons/${id ? `${id}/` : ''}`
  };
};

export const getSeasonResorts = identifier => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `seasons/${identifier}/get_season_resorts/`
  };
};

export const getPredefinedFilters = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `seasons/get_predefined_filters/?id=${id}&module_id=${state.app.module}`
  };
};

export const getInitResortEventCampTableDataAction = () => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `seasons/get_init_resort_event_camp_table_data/?season_id=${state.app.season}`
  };
};

export const getResortsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `resorts/?seasons=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitResortAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `resorts/${id ? `${id}/` : ''}`
  };
};

export const getCampsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `camps/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitCampAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `camps/${id ? `${id}/` : ''}`
  };
};

export const getCampContactDetailsAction = (campId, search) => {
  const state = store.getState();
  let qs = '';
  if (campId) {
    qs += `camp=${campId}&`;
  }
  if (search) {
    qs += `search=${encodeURIComponent(search)}&`;
  }

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `camp-contact-details/?${qs}`
  };
};

export const submitCampContactDetailsAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `camp-contact-details/${id ? `${id}/` : ''}`
  };
};

export const getEventsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `events/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitEventAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `events/${id ? `${id}/` : ''}`
  };
};

export const getAccomodationsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `accomodations/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitAccomodationAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `accomodations/${id ? `${id}/` : ''}`
  };
};

export const getAgeRangesAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `age-ranges/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitAgeRangeAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `age-ranges/${id ? `${id}/` : ''}`
  };
};

export const getParticipantsAction = (page, pageSize, val) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `participants/?page=${page}&page_size=${pageSize}${search}`
  };
};

export const submitParticipantsAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `participants/${id ? `${id}/` : ''}`
  };
};

export const getPurchasersAction = (page, pageSize, val) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `purchasers/?page=${page}&page_size=${pageSize}${search}`
  };
};

export const submitPurchasersAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `purchasers/${id ? `${id}/` : ''}`
  };
};

export const getActivitiesAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `activities/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitActivityAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `activities/${id ? `${id}/` : ''}`
  };
};

export const getPeriodsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `periods/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const getDiscountedGrossValuePerParticipantTitlesAction = (
  val,
  method
) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `promotions/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitPeriodAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `periods/${id ? `${id}/` : ''}`
  };
};

export const getPaymentDateRangesAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `payment-date-ranges/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitPaymentDateRangeAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;
  body.season = state.app.season;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `payment-date-ranges/${id ? `${id}/` : ''}`
  };
};

export const getPiggyBankConfigsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `piggy-bank-configs/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitPiggyBankConfigAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;
  body.season = state.app.season;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `piggy-bank-configs/${id ? `${id}/` : ''}`
  };
};

export const getPiggyBankEntriesAction = (purchaserId, method) => {
  const state = store.getState();

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `piggy-bank-entries/?purchaser=${purchaserId}`
  };
};

export const submitPiggyBankEntryAction = (body, method) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'piggy-bank-entries/'
  };
};

export const getPiggyBankAction = purchaserId => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `piggy-banks/?purchaser=${purchaserId}`
  };
};

export const getTimedSlotsControlAction = (val, method, resortId) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;
  const resort = _.isNil(resortId) ? '' : `&resort=${resortId}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `timed-slots-controls/?season=${state.app.season}&module=${state.app.module}${search}${resort}`
  };
};

export const submitTimedSlotsControlAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;
  body.season = state.app.season;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `timed-slots-controls/${id ? `${id}/` : ''}`
  };
};

export const getOrderDetailsAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/get_details/`
  };
};

export const getOrdersAction = (
  page,
  pageSize,
  searchValue,
  orderFilters,
  searchFields,
  sortFields
) => {
  const state = store.getState();
  const search = _.isNil(searchValue) ? '' : `&search=${searchValue}`;
  const sort = _.isEmpty(sortFields) ? '' : `&ordering=${sortFields}`;
  if (orderFilters === undefined || _.isEmpty(orderFilters)) {
    return {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${state.app.token}`
      },
      endpoint: `orders/?page=${page}&page_size=${pageSize}&module=${state.app.module}&season=${state.app.season}${search}&search_fields=${searchFields}${sort}`
    };
  }

  let filters = '';
  let camps = '';
  let resorts = '';
  let events = '';
  const consents = [];

  for (const element of orderFilters) {
    if (element === 'return_documents') {
      filters += `&return_documents=${false}`;
    }

    if (element === 'canoeing_activities') {
      filters += `&canoeing_activities=${true}`;
    }

    if (element === 'return_agreement') {
      filters += `&return_agreement=${false}`;
    }

    if (element === 'return_of_health_card') {
      filters += `&return_of_health_card=${false}`;
    }

    if (element === 'annex_return') {
      filters += `&annex_return=${false}`;
    }

    if (element === 'accommodated') {
      filters += `&accommodated=${true}`;
    }

    if (element === 'provisions') {
      filters += `&provisions=${true}`;
    }

    if (element === 'is_paid') {
      filters += `&is_paid=${true}`;
    }
    if (element === 'is_paid_advance') {
      filters += `&is_paid_advance=${true}`;
    }

    if (element === 'deductions') {
      filters += `&deductions=${true}`;
    }

    if (element === 'is_unpaid') {
      filters += `&is_unpaid=${true}`;
    }

    if (element === 'is_unpaid_advance') {
      filters += `&is_unpaid_advance=${true}`;
    }

    if (element === 'discount_cancelled') {
      filters += `&discount_cancelled=${true}`;
    }

    if (element === 'other_terms') {
      filters += `&other_terms=${true}`;
    }

    if (element === 'marketing_consents_email') {
      filters += `&marketing_consents_email=${true}`;
    }

    if (element === 'marketing_consents_sms') {
      filters += `&marketing_consents_sms=${true}`;
    }

    if (element === 'marketing_consents_phone') {
      filters += `&marketing_consents_phone=${true}`;
    }

    if (element === 'qualification_card_returned') {
      filters += `&qualification_card_returned=${true}`;
    }

    if (element === 'qualification_card_not_returned') {
      filters += `&qualification_card_not_returned=${true}`;
    }

    if (element === 'return_agreement_true') {
      filters += `&return_agreement_true=${true}`;
    }

    if (element === 'return_of_health_card_true') {
      filters += `&return_of_health_card_true=${true}`;
    }

    if (element === 'has_shared_accommodation_info') {
      filters += `&has_shared_accommodation_info=${true}`;
    }

    if (element === 'has_not_shared_accommodation_info') {
      filters += `&has_not_shared_accommodation_info=${true}`;
    }

    if (typeof element === 'object') {
      for (const property in element) {
        if (element[property] !== null) {
          filters += `&${property}=${element[property]}`;
        }
      }
    } else {
      if (element.startsWith('state')) {
        const state = element.split('-');
        filters += `&state=${state[1]}`;
      }
      if (
        element.startsWith('classification') &&
        element !== 'classification'
      ) {
        const classification = element.split('-');
        filters += `&classification=${classification[1]}`;
      }

      if (element.startsWith('camp')) {
        const camp = element.split('-');
        if (camps.length === 0) {
          camps += camp[1];
        } else {
          camps += `,${camp[1]}`;
        }
      }

      if (element.startsWith('variant') && element !== 'variant') {
        filters += `&variant=${element}`;
      }

      if (element.startsWith('resort')) {
        const resort = element.split('-');
        if (resorts.length === 0) {
          resorts += resort[1];
        } else {
          resorts += `,${resort[1]}`;
        }
      }

      if (element.startsWith('event')) {
        const event = element.split('-');
        if (events.length === 0) {
          events += event[1];
        } else {
          events += `,${event[1]}`;
        }
      }

      if (element.startsWith('consent-')) {
        const consent = element.split('-');
        consents.push(consent[1]);
      }
    }
  }

  if (camps.length > 0) {
    filters += `&camps=${camps}`;
  }

  if (resorts.length > 0) {
    filters += `&resorts=${resorts}`;
  }

  if (events.length > 0) {
    filters += `&events=${events}`;
  }

  if (consents.length > 0) {
    consents.forEach(c => {
      filters += `&consents=${encodeURIComponent(c)}`;
    });
  }

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/?page=${page}&page_size=${pageSize}&module=${state.app.module}&season=${state.app.season}${filters}${search}&search_fields=${searchFields}${sort}`
  };
};

export const updateOrderAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/`,
    body
  };
};

export const deleteOrderAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/`
  };
};

export const duplicateOrderAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/duplicate/`
  };
};

export const getInvoiceDataAction = (id, type) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/get_invoice_data/?type=${type}&season=${state.app.season}&module=${state.app.module}&order_id=${id}`
  };
};

export const updateInvoiceNumberAction = (id, type, issue_date) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/update_invoice_number/?type=${type}&issue_date=${issue_date}&order_id=${id}&season=${state.app.season}&module=${state.app.module}`
  };
};

export const getOrderOptionsAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/get_order_numbers/?season=${state.app.season}&module=${state.app.module}`
  };
};

export const getPromotionsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `promotions/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitPromotionAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `promotions/${id ? `${id}/` : ''}`
  };
};

export const getPromotionPredefinedFilters = (id, title) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `promotions/get_predefined_filters/?season_id=${id}&title=${title}`
  };
};

export const getDocuments = (id, template_name, annex_id = 0) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `orders/${id}/documents/?template_name=${template_name}&annex_id=${annex_id}`
  };
};

export const sendDocument = (
  id,
  template_name,
  body = {},
  documentName = 'dokument'
) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    body,
    endpoint: `orders/${id}/documents/?template_name=${template_name}&document_name=${documentName}`
  };
};

export const refreshOrderDocumentAction = (id, documentType = 'dokument') => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/refresh_order_document/?document_type=${documentType}`
  };
};

export const sendOrderMail = (id, body = {}) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `orders/${id}/send_mail/`
  };
};

export const sendSetOfDocumentsAction = (id, body = {}) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `orders/${id}/send_set_of_documents/`
  };
};

export const createAgreementAnnexAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/create_annex/`
  };
};

export const createAgreementAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/create_agreement/`
  };
};

export const sendAgreementAnnexAction = (id, annex_id, body) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `orders/${id}/send_annex/?annex_id=${annex_id}`
  };
};

export const getFormPromotionsAction = (identifier, params) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `seasons/${identifier}/get_promotions/?${params}`
  };
};

export const getDependsOnEventAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `events/get_depends_on_action/?id=${id}`
  };
};

export const getDependsOnCampAction = params => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `camps/get_depends_on_data/?${params}`
  };
};

export const getTransportPrice = params => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `transports/get_transport_price/?${params}`
  };
};

export const getOrderPrice = body => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'POST',
    headers,
    endpoint: 'events/get_order_price/',
    body
  };
};

export const getCustomFormCalculatorData = body => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'POST',
    headers,
    endpoint: 'events/get_custom_form_calculator_data/',
    body
  };
};

export const getWROrderPrice = body => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'POST',
    headers,
    endpoint: 'events/get_wr_order_price/',
    body
  };
};

export const getZSOrderPrice = body => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'POST',
    headers,
    endpoint: 'events/get_zs_order_price/',
    body
  };
};

export const getDependsOnCampPLAction = params => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `camps/get_depends_on_data_pl/?${params}`
  };
};

export const getDiscountAction = params => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `promotions/get_discount_action/?${params}`
  };
};

export const getObozyDiscountAction = params => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `promotions/get_obozy_discount_action/?${params}`
  };
};

export const getTransportsAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `transports/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const getTransportsSeatsControlAction = (method = 'GET') => {
  const state = store.getState();

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `transport-seats-control/?season=${state.app.season}&module=${state.app.module}`
  };
};

export const getTransportsSeatsControlAvailableCamps = type => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `transport-seats-control/get_available_camps/?season_id=${state.app.season}&type=${type}`
  };
};

export const getTransportsSeatsControlAvailableTransports = (
  camp,
  type,
  control_id
) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `transport-seats-control/get_available_transports/?season_id=${
      state.app.season
    }&camp_id=${camp}&type=${type}${
      control_id ? `&control_id=${control_id}` : ''
    }`
  };
};

export const submitTransportsSeatsControlAction = (body, method, id) => {
  const state = store.getState();
  body.season = state.app.season;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `transport-seats-control/${id ? `${id}/` : ''}`
  };
};

export const submitTransportAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `transports/${id ? `${id}/` : ''}`
  };
};

export const getModulesAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'modules/get_employee_modules/'
  };
};

export const getModuleViewsAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `module-views/?module=${state.app.module}`
  };
};

export const submitModuleViewAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `module-views/${id ? `${id}/` : ''}`
  };
};

export const sendNotificationAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'notifications/send_custom_notification/',
    body
  };
};

export const sendNotificationsAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'notifications/send_custom_notifications/',
    body
  };
};

export const sendMessagesAction = (body, type) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `notifications/send_messages/?type=${type}`,
    body
  };
};

export const getTemplateProductsAction = val => {
  const state = store.getState();
  let search = _.isNil(val) ? '?' : `?search=${val}&`;
  search += 'template=true';

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `products/${search}`
  };
};

export const submitProductAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `products/${id ? `${id}/` : ''}`
  };
};

export const submitInvoiceAction = (body, method, id) => {
  const state = store.getState();

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `invoices/${id ? `${id}/` : ''}`,
    body
  };
};

export const getInvoiceDocuments = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `invoices/${id}/documents/`
  };
};

export const sendInvoiceDocument = (id, body) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `invoices/${id}/documents/`
  };
};

export const getDocumentsAction = val => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `invoices/${val}season=${state.app.season}&module=${state.app.module}`
  };
};

export const changeDGCSStatusAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `invoices/${id}/change_dgcs_status/`
  };
};

export const changeFiscalizationStatusAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `invoices/${id}/change_fiscalization_status/`
  };
};

export const sendBankStatements = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'payments/bank_statements/'
  };
};

export const sendBankStatementsCollect = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'payments/bank_statements_collect/'
  };
};

export const sendBankStatementsSpreadsheet = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'payments/bank_statements_spreadsheet/'
  };
};

export const matchBankStatementsWithOrdersAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'orders/match_bank_statements_with_orders/'
  };
};

export const getOrderFieldsAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/fields/?module=${state.app.module}`
  };
};

export const getSpreadsheetTemplate = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `spreadsheet-template/${id}/?module=${state.app.module}`
  };
};

export const getSpreadsheetTemplates = (tab = '') => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `spreadsheet-template/?module=${state.app.module}&tab=${tab}`
  };
};

export const createSpreadsheetTemplate = body => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'spreadsheet-template/'
  };
};

export const updateSpreadsheetTemplate = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `spreadsheet-template/${id}/?module=${state.app.module}`
  };
};

export const deleteSpreadsheetTemplateAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `spreadsheet-template/${id}/?module=${state.app.module}`
  };
};

export const downloadSpreadsheet = (id, body) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: `spreadsheet-template/${id}/download_spreadsheet/?module=${state.app.module}`
  };
};

export const getNotificationSettingsAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `notification-settings/?page_size=100&module=${state.app.module}&season=${state.app.season}`
  };
};

export const updateNotificationSettingsAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `notification-settings/${id}/`,
    body
  };
};

export const updateEmployeeConfigAction = (body, id) => {
  const state = store.getState();

  return {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `employee-configs/${id}/`
  };
};

export const getClientDataAction = () => {
  const state = store.getState();

  const headers = {
    'Content-Type': 'application/json'
  };

  if (state.app.token) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    credentials: 'include', // fetch
    endpoint: 'purchasers/client_data/'
  };
};

export const getClientKidsAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'purchasers/client_kids/'
  };
};

export const getClientOrdersAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'purchasers/client_orders/'
  };
};

export const getClientZSDataAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'purchasers/client_data_zs/'
  };
};

export const getClientDocument = (id, params) => {
  const state = store.getState();
  const queryParams = new URLSearchParams(params).toString();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `purchasers/${id}/download_document/?${queryParams}`
  };
};

export const getClientSettlementDocument = (id, params) => {
  const state = store.getState();
  const queryParams = new URLSearchParams(params).toString();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `purchasers/${id}/download_settlement_document/?${queryParams}`
  };
};

export const getClientABCDocument = fileName => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `purchasers/download_abc_pdf/?file_name=${fileName}`
  };
};

export const getClientScheduleDocument = (id, params) => {
  const state = store.getState();
  const queryParams = new URLSearchParams(params).toString();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `purchasers/${id}/download_schedule_pdf/?${queryParams}`
  };
};

export const getTransportReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: `orders/transport_report/?season=${state.app.season}&module=${state.app.module}`
  };
};

export const getPromotionsReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: `orders/promotions_report/?module=${state.app.module}&season_id=${state.app.season}`
  };
};

export const getSeatAvailabilityReport = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `orders/seat_availability_report/?module=${state.app.module}&season_id=${state.app.season}`
  };
};

export const getSeatAvailabilityResortReport = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `orders/seat_availability_resort_report/?module=${state.app.module}&season_id=${state.app.season}`
  };
};

export const seatAvailabilityExcelReportAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: `orders/seat_availability_excel_report/?module=${state.app.module}&season_id=${state.app.season}`
  };
};

export const seatAvailabilityExcelReportNoAgeRangeAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: `orders/seat_availability_excel_report_no_age_range/?module=${state.app.module}&season_id=${state.app.season}`
  };
};

export const getListOfReceiptsReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: `orders/list_of_receipts/?module=${state.app.module}`
  };
};

export const getListOfReceiptsExcelReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: `invoices/list_of_receipts/?module=${state.app.module}&season_id=${state.app.season}`
  };
};

export const createSyntheticAccountsErrorsExcelReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    body,
    endpoint: 'invoices/synthetic_accounts_errors_report/'
  };
};

export const createFinishedEventsExcelReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    body: { ...body, module: state.app.module },
    endpoint: 'orders/finished_events_report/'
  };
};

export const eventGroupExcelReport = body => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `events/event_group_report/?module=${state.app.module}&season_id=${state.app.season}`
  };
};

export const getSaleExecutionReport = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `events/sale_execution_report/?module=${state.app.module}&season_id=${state.app.season}`
  };
};

export const getComprehensiveSalesPlanReport = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `events/comprehensive_sales_plan_report/?module=${state.app.module}&season_id=${state.app.season}`
  };
};

export const getTransport2Report = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `orders/transport_report_2/?module=${state.app.module}&season_id=${state.app.season}`
  };
};

export const getActivitiesListReport = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `orders/activities_list_report/?module=${state.app.module}&season_id=${state.app.season}`
  };
};

export const getResignationReport = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `orders/resignations_report/?module=${state.app.module}&season_id=${state.app.season}`
  };
};

export const getInitialNoPlacesOrdersReport = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `orders/initial_no_places_orders_report/?module=${state.app.module}&season_id=${state.app.season}`
  };
};

export const createSurchargeEventsExcelReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    body: { ...body, module: state.app.module },
    endpoint: 'orders/surcharge_events_report/'
  };
};

export const calculateRoadToSchoolDistance = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/calculate_school_distance/`
  };
};

export const getEndSalesReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: 'orders/end_sales_statement/'
  };
};

export const createZSProductsAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `orders/${id}/create_zs_products/`
  };
};

export const senMessageWithUrlForTransaction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'orders/send_message_with_url_for_transaction/',
    body
  };
};

export const changeFormEventAction = id => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `events/${id ? id : 0}/change_form_event/`
  };
};

export const changeFormPLEventAction = id => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `events/${id ? id : 0}/change_form_pl_event/`
  };
};

export const deleteProductAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `products/${id}/`
  };
};

export const updateProductAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `products/${id}/`,
    body
  };
};

export const addPositionsAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `orders/${id}/add_positions/`
  };
};

export const duplicateEventAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `events/${id}/duplicate/`
  };
};

export const getPromotionStatisticsDataAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `promotions/get_statistics_data/?season_id=${state.app.season}`
  };
};

export const getResortStatisticsDataAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `resorts/${id}/get_statistics_data/?season_id=${state.app.season}&module_id=${state.app.module}`
  };
};

export const getDetailCampStatisticsDataAction = (id, resort) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `camps/${id}/get_detail_statistics_data/?season_id=${state.app.season}&module_id=${state.app.module}&resort_id=${resort}`
  };
};

export const getGeneralCampStatisticsDataAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `camps/${id}/get_general_statistics_data/?season_id=${state.app.season}&module_id=${state.app.module}`
  };
};

export const getDetailEventStatisticsDataAction = (id, resort) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `events/${id}/get_detail_statistics_data/?season_id=${state.app.season}&module_id=${state.app.module}&resort_id=${resort}`
  };
};

export const getGeneralEventStatisticsDataAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `events/${id}/get_general_statistics_data/?season_id=${state.app.season}&module_id=${state.app.module}`
  };
};

export const getResortEvents = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `resorts/${id}/get_resort_events/?season_id=${state.app.season}`
  };
};

export const getSeasonDerivatesAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `seasons/get_derivates/?season_id=${state.app.season}`
  };
};

export const getGlobalStatisticsDataAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `seasons/get_global_statistics_data/?season_id=${
      id ? id : state.app.season
    }&module_id=${state.app.module}`
  };
};

export const getAllSeasonStatisticsDataAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `seasons/get_global_statistics_data/?module_id=${state.app.module}`
  };
};

export const getHistoricDataByPeselAction = val => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/get_historic_data_by_pesel/?pesel=${val}`
  };
};

export const validateOrderNumberAction = number => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/validate_order_number/?number=${number}`
  };
};

export const submitFormRatingAction = body => {
  const state = store.getState();
  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    body,
    method: 'POST',
    headers,
    endpoint: 'form-ratings/'
  };
};

export const getFormRatingsCommentsAction = () => {
  const state = store.getState();
  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: 'form-ratings/form_ratings_comments/'
  };
};

export const deleteAgreementAnnexAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `agreement-annex/${id}/`
  };
};

export const updateAgreementAnnexAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `agreement-annex/${id}/`,
    body
  };
};

export const updateOrderDocumentAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `documents/${id}/`,
    body
  };
};

export const getAlertsAction = () => {
  const state = store.getState();
  const module = state.app.module;

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `alerts/?module_identifier=${module}`
  };
};

export const submitAlertAction = body => {
  const state = store.getState();

  return {
    body,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'alerts/'
  };
};

export const markAlertAsReadAction = id => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `alerts/${id}/mark_as_read/`
  };
};

export const getEventSlotsAvailabilityDataAction = val => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `events/get_slots_availability_data/?season_id=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const getTransportReportDataAction = val => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `transports/get_transport_report_data/?season_id=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const getTransportSumAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/transport_sum_report/?season_id=${state.app.season}&module=${state.app.module}`
  };
};

export const getTransportReportAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: 'transports/transport_report/'
  };
};

export const getNotificationSettingsDetail = type => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `notification-settings/get_settings_details/?module=${state.app.module}&type=${type}&season_id=${state.app.season}`
  };
};

export const deleteAgreement = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/delete_agreement/`
  };
};

export const getMainReportZS = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: 'orders/main_report_zs/'
  };
};

export const getQualificationCardList = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: 'orders/qualification_card_list/'
  };
};

export const getMainReportZSManager = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: `orders/main_report_zs_manager/?season=${state.app.season}`
  };
};

export const getAnalizeReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: `orders/analize_report/?season=${state.app.season}&module=${state.app.module}`
  };
};

export const refreshAgreementData = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/refresh_agreement/`
  };
};

export const refreshAnnexData = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/refresh_annex/`
  };
};

export const getBankStatementsAction = filters => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `bank-statements/${filters}`
  };
};

export const deleteBankStatementAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `bank-statements/${id}/`
  };
};

export const submitTransactionAction = (id, method, body) => {
  const state = store.getState();

  return {
    method,
    body,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `transactions/${id}/`
  };
};

export const splitTransactionAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PUT',
    body,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `transactions/${id}/split_transaction/`
  };
};

export const getDietAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `diets/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitDietAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `diets/${id ? `${id}/` : ''}`
  };
};

export const sendAgreementTemplate = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'agreement-template/'
  };
};

export const getAgreementTemplateAction = (
  method,
  val = null,
  module = null
) => {
  const state = store.getState();

  const params = new URLSearchParams();

  if (!_.isNil(val) && val !== '') {
    params.append('search', val);
  }

  if (!_.isNil(module) && module !== '') {
    params.append('module', module);
  }

  params.append('season', state.app.season);

  const query = params.toString();
  const endpoint = query
    ? `agreement-template/?${query}`
    : 'agreement-template/';

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint
  };
};

export const sendInvoiceTemplate = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'invoice-template/'
  };
};

export const getInvoiceTemplateAction = (method, val = null) => {
  const state = store.getState();

  const params = new URLSearchParams();

  if (!_.isNil(val) && val !== '') {
    params.append('search', val);
  }

  const query = params.toString();
  const endpoint = query ? `invoice-template/?${query}` : 'invoice-template/';

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint
  };
};

export const submitWorkStandardAction = (body, id, method) => {
  const state = store.getState();
  const idSuffix = id ? `${id}/` : '';

  return {
    method,
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `work-standards/${idSuffix}`
  };
};

export const getWorkStandardsAction = (method, search, page, pageSize) => {
  const state = store.getState();
  const season = state.app.season;

  const params = new URLSearchParams({
    page: page + 1,
    page_size: pageSize,
    season
  });

  if (search) {
    params.append('search', search);
  }

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `work-standards/?${params.toString()}`
  };
};

export const deleteWorkStandardAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `work-standards/${id}/`
  };
};

export const downloadWorkStandardAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `work-standards/${id}/download_file/`
  };
};

export const checkWorkStandardFileAction = id => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `work-standards/${id}/check_file/`
  };
};

export const submitPersonalDataProtectionDocumentAction = (
  body,
  id,
  method
) => {
  const state = store.getState();
  const idSuffix = id ? `${id}/` : '';

  return {
    method,
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `personal-data-protection-documents/${idSuffix}`
  };
};

export const getPersonalDataProtectionDocumentsAction = (
  method,
  search,
  page,
  pageSize
) => {
  const state = store.getState();
  const season = state.app.season;

  const params = new URLSearchParams({
    page: page + 1,
    page_size: pageSize,
    season
  });

  if (search) {
    params.append('search', search);
  }

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `personal-data-protection-documents/?${params.toString()}`
  };
};

export const deletePersonalDataProtectionDocumentAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `personal-data-protection-documents/${id}/`
  };
};

export const downloadPersonalDataProtectionDocumentAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `personal-data-protection-documents/${id}/download_file/`
  };
};

export const checkPersonalDataProtectionFileAction = id => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `personal-data-protection-documents/${id}/check_file/`
  };
};

export const submitOrganizingCampsInstructionDocumentAction = (
  body,
  id,
  method
) => {
  const state = store.getState();
  const idSuffix = id ? `${id}/` : '';

  return {
    method,
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `organizing-camps-instruction-documents/${idSuffix}`
  };
};

export const getOrganizingCampsInstructionDocumentsAction = (
  method,
  search,
  page,
  pageSize
) => {
  const state = store.getState();
  const season = state.app.season;

  const params = new URLSearchParams({
    page: page + 1,
    page_size: pageSize,
    season
  });

  if (search) {
    params.append('search', search);
  }

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `organizing-camps-instruction-documents/?${params.toString()}`
  };
};

export const deleteOrganizingCampsInstructionDocumentAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `organizing-camps-instruction-documents/${id}/`
  };
};

export const downloadOrganizingCampsInstructionDocumentAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `organizing-camps-instruction-documents/${id}/download_file/`
  };
};

export const checkOrganizingCampsInstructionFileAction = id => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `organizing-camps-instruction-documents/${id}/check_file/`
  };
};

export const sendEssentialDocument = (body, id, method) => {
  const state = store.getState();
  const idSuffix = id ? `${id}/` : '';

  return {
    method,
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `essential-documents/${idSuffix}`
  };
};

export const getEssentialDocumentsAction = (method, search, page, pageSize) => {
  const state = store.getState();
  const season = state.app.season;

  const params = new URLSearchParams({
    page: page + 1,
    page_size: pageSize,
    season
  });

  if (search) {
    params.append('search', search);
  }

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `essential-documents/?${params.toString()}`
  };
};

export const deleteEssentialDocumentAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `essential-documents/${id}/`
  };
};

export const downloadEssentialDocumentAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `essential-documents/${id}/download_file/`
  };
};

export const checkEssentialDocumentAction = id => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `essential-documents/${id}/check_file/`
  };
};

export const sendTemplateDocument = (body, id, method) => {
  const state = store.getState();
  const idSuffix = id ? `${id}/` : '';

  return {
    method,
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `template-documents/${idSuffix}`
  };
};

export const getTemplateDocumentsAction = (method, search, page, pageSize) => {
  const state = store.getState();
  const season = state.app.season;

  const params = new URLSearchParams({
    page: page + 1,
    page_size: pageSize,
    season
  });

  if (search) {
    params.append('search', search);
  }

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `template-documents/?${params.toString()}`
  };
};

export const deleteTemplateDocumentAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `template-documents/${id}/`
  };
};

export const downloadTemplateDocumentAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `template-documents/${id}/download_file/`
  };
};

export const checkTemplateDocumentAction = id => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `template-documents/${id}/check_file/`
  };
};

export const deleteAgreementTemplateAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `agreement-template/${id}/`
  };
};

export const editAgreementTemplateAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    body,
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `agreement-template/${id}/`
  };
};

export const downloadAgreementTemplateAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `agreement-template/${id}/download_template/`
  };
};

export const deleteInvoiceTemplateAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `invoice-template/${id}/`
  };
};

export const editInvoiceTemplateAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    body,
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `invoice-template/${id}/`
  };
};

export const downloadInvoiceTemplateAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `invoice-template/${id}/download_template/`
  };
};

export const getFormMetaDataAction = id => {
  const state = store.getState();
  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'OPTIONS',
    headers,
    endpoint: `forms/${id}/`
  };
};

export const getInvoiceFieldsAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'invoices/fields/'
  };
};

export const downloadInvoiceSpreadsheet = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: 'invoices/download_spreadsheet/'
  };
};

export const downloadListOfInvoices = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: `invoices/list_of_invoices/?module=${state.app.module}`
  };
};

export const getSlotsControlReport = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: 'slots-controls/slots_control_report/'
  };
};

export const getEmployeeApplications = (
  method = 'GET',
  id = null,
  val = null,
  filtersParams = null
) => {
  const state = store.getState();
  const search = _.isNil(val) || val.length === 0 ? '' : `&search=${val}`;
  const filter = _.isNil(filtersParams)
    ? ''
    : _.isNil(val) || val.length === 0
      ? `&${filtersParams}`
      : `&${filtersParams}`;
  const params = `${search}${filter}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-applications/${
      id
        ? `${id}/`
        : `?season=${state.app.season ? state.app.season : 2025}${params}`
    }`
  };
};

export const updateEmployeeApplication = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-applications/${id}/`,
    body
  };
};

export const createApplicationBasedOnEmployeeData = body => {
  const state = store.getState();
  body.season = state.app.season;

  return {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint:
      'employee-applications/create_application_based_on_employee_data/',
    body
  };
};

export const duplicateEmployeeApplication = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-applications/${id}/duplicate_employee_application/`
  };
};

export const createEmployeeAgrementAction = id => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-applications/${id}/create_agreement/`
  };
};

export const createEmployeeAnnexAction = id => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-applications/${id}/create_annex/`
  };
};

export const deleteEmployeeAnnexAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-applications/${id}/delete_annex/`
  };
};

export const getAgreementDocuments = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `employee-applications/${id}/get_agreement_file/`
  };
};

export const createQuestionnaireAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-applications/${id}/create_questionnaire/`
  };
};

export const downloadQuestionnaireFileAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `employee-applications/${id}/download_questionnaire/`
  };
};

export const addAttachmentAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `employee-applications/${id}/add_attachment/`
  };
};

export const addAttachmentEmployeeAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `employees/${id}/add_attachment/`
  };
};

export const deleteAttachmentAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `attachment/${id}/`
  };
};

export const downloadAttachmentAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `attachment/${id}/download_attachment/`
  };
};

export const verifyCodeQuestionnaireAction = (id, body) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'POST',
    headers,
    body,
    endpoint: `questionnaire/${id}/verify_code/`
  };
};

export const updateQuestionnaireAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `questionnaire/${id}/`
  };
};

export const createEmployeeAnexAction = id => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-applications/${id}/create_agreement/`
  };
};

export const refreshEmployeeAgreementAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-applications/${id}/refresh_agreement/`
  };
};

export const deleteEmployeeAgrementAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-applications/${id}/delete_agreement/`
  };
};

export const getEmployeeDocumentsAction = (
  id,
  template_name,
  fileName,
  annex_id = 0
) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `employee-applications/${id}/get_documents/?template_name=${template_name}&file_name=${fileName}&annex_id=${annex_id}`
  };
};

export const getEmployeesAction = (
  method = 'GET',
  id = null,
  val = null,
  filtersParams = null
) => {
  const state = store.getState();
  const search = _.isNil(val) || val.length === 0 ? '' : `?search=${val}`;
  const filter = _.isNil(filtersParams)
    ? ''
    : _.isNil(val) || val.length === 0
      ? `?${filtersParams}`
      : `&${filtersParams}`;
  const params = `${search}${filter}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employees/${id ? `${id}/` : `${params}`}`
  };
};

export const updateEmployeeAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employees/${id}/`,
    body
  };
};

export const createEmploymentHistoryAction = (body, id = null) => {
  const state = store.getState();

  return {
    method: id === null ? 'POST' : 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `employment-history/${id ? `${id}/` : ''}`
  };
};

export const deleteEmploymentHistoryAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employment-history/${id}/`
  };
};

export const createEmploymeeInformationAction = (body, id = null) => {
  const state = store.getState();

  return {
    method: id === null ? 'POST' : 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `employee-information/${id ? `${id}/` : ''}`
  };
};

export const deleteEmploymeeInformationAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-information/${id}/`
  };
};

export const sendEmployeeDocument = (
  id,
  template_name,
  body = {},
  annex_nr = 0,
  documentName = 'dokument'
) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    body,
    endpoint: `employee-applications/${id}/send_documents/?template_name=${template_name}&document_name=${documentName}&annex_nr=${annex_nr}`
  };
};

export const downloadEmployeeApplicationSpreadsheet = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: 'employee-applications/download_spreadsheet/'
  };
};

export const getBonusReport = body => {
  const state = store.getState();
  const season = state.app.season;

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: `employee-applications/bonus_report/?season_id=${season}`
  };
};

export const downloadEmployeeSpreadsheet = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: 'employees/download_spreadsheet/'
  };
};

export const getEmployeeApplicationFields = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'employee-applications/fields/'
  };
};

export const getEmployeeFields = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'employees/fields/'
  };
};

export const sendSetOfEmployeeDocumentsAction = (id, body = {}) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `employee-applications/${id}/send_set_of_documents/`
  };
};

export const getEmployeeApplicationHistoryAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-applications/${id}/get_history/`
  };
};

// ENDPOINTY PODPISYWANIE DOKUMENTÓW

export const getDocumentToSignAction = (
  id,
  template_name,
  fileName,
  model,
  annex_nr = 0
) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    responseType: 'blob',
    endpoint: `sign_documents/${id}/get_documents/?template_name=${template_name}&file_name=${fileName}&annex_nr=${annex_nr}&model=${model}`
  };
};

export const signDocumentAction = (body, id) => ({
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  endpoint: `sign_documents/${id}/sign_document/`,
  body
});

export const getInstanceSignAgreementData = (id, model) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    endpoint: `sign_documents/${id}/get_instance_data/?model=${model}`
  };
};

export const sendMailsWithSigningData = (id, body) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `sign_documents/${id}/send_mails_with_signing_data/`
  };
};

export const unsignAgreementAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `sign_documents/${id}/unsign_agreement/`
  };
};

export const verifyDocumentCodeAction = (id, body) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  return {
    method: 'POST',
    headers,
    body,
    endpoint: `sign_documents/${id}/verify_code/`
  };
};

// //////////////////////////////////////////////////////////////////

export const updateAgreementAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `agreements/${id}/`,
    body
  };
};

export const sendAgreementsToDGCSAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'notifications/send_agreements_to_dgcs/',
    body
  };
};

export const getCalendarDaySlotsAction = (resortId, controlDate) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `calendar-day-slots-control/get_calendar_day_slots/?resort_id=${resortId}&control_date=${controlDate}`
  };
};

export const submitCalendarDaySlotsAction = (body, id) => {
  const state = store.getState();

  return {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `calendar-day-slots-control/${id}/`
  };
};

export const checkSlotsControlAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `orders/${id}/check_slots_control/`
  };
};

export const getAccomodationChoicesDataAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `accomodation-diagrams/get_accomodation_choices_data/?season_id=${state.app.season}&module=${state.app.module}`
  };
};

export const submitAccomodationDiagramAction = (body, method, id) => {
  const state = store.getState();
  if (method == 'POST') {
    body.season = state.app.season;
    body.module = state.app.module;
  }

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `accomodation-diagrams/${id ? `${id}/` : ''}`,
    body
  };
};

export const deleteAccomodationDiagramAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `accomodation-diagrams/${id}/`
  };
};

export const getAvailableOrdersToAccomodateAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `accomodation-diagrams/${id}/get_available_orders_to_accomodate/`
  };
};

export const getManagementReport = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `accomodation-diagrams/${id}/management_report/`
  };
};

export const cloneAccomodationDiagramAction = (body, id) => {
  const state = store.getState();
  body.season = state.app.season;
  body.module = state.app.module;

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `accomodation-diagrams/${id}/clone_accommodation_diagram/`,
    body
  };
};

export const changeAccommodationOwnershipAction = (body, id) => {
  const state = store.getState();
  body.season = state.app.season;
  body.module = state.app.module;

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `accomodation-diagrams/${id}/change_ownership/`,
    body
  };
};

export const getOrderDocumentAction = (id, document_type) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `orders/${id}/get_draft_document/?document_type=${document_type}`
  };
};

export const updateDraftDocumentAction = (id, document_type, body) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'PUT',
    headers,
    body,
    endpoint: `orders/${id}/update_draft_document/?document_type=${document_type}`
  };
};

export const mergeOrderDocumentsAction = (body, id) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      // 'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `orders/${id}/merge_order_documents/`
  };
};

export const getOrderAttachmentAction = (id, attachment_id) => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `orders/${id}/get_order_attachment/?attachment_id=${attachment_id}`
  };
};

export const removeOrderAttachmentAction = (id, attachment_id) => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `orders/${id}/remove_order_attachment/?attachment_id=${attachment_id}`
  };
};

export const getAgreementDynamicSections = (method, val = null) => {
  const state = store.getState();

  const params = new URLSearchParams();

  if (!_.isNil(val) && val !== '') {
    params.append('search', val);
  }

  const query = params.toString();
  const endpoint = query
    ? `dynamic-sections/?${query}&season=${state.app.season}`
    : `dynamic-sections/?season=${state.app.season}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint
  };
};

export const createDynamicSection = (body, method = 'POST', id = null) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method,
    headers,
    endpoint: `dynamic-sections/${id ? `${id}/` : ''}`,
    body
  };
};

export const verifySharedAccommodationCodeAction = (id, body) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'POST',
    headers,
    body,
    endpoint: `orders/${id}/verify_shared_accommodation_code/`
  };
};

export const changeSharedAccommodationInfoAction = (id, body) => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'PUT',
    headers,
    body,
    endpoint: `orders/${id}/change_shared_accommodation_info/`
  };
};

export const getBonusesAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `bonuses/?season=${state.app.season}${search}`
  };
};

export const submitBonusAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `bonuses/${id ? `${id}/` : ''}`
  };
};

export const getStaffApplicationsAction = method => {
  const state = store.getState();

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'employees/staff_applications/'
  };
};

export const submitEmployeeSunActiveRecord = (id, body) => {
  const state = store.getState();

  return {
    method: id ? 'PUT' : 'POST',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `employee-sun-active-points/${id ? `${id}/` : ''}`
  };
};

export const deleteEmployeeSunActiveRecord = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-sun-active-points/${id}/`
  };
};

export const submitEmployeeReviewRecord = (id, body) => {
  const state = store.getState();

  return {
    method: id ? 'PUT' : 'POST',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `employee-reviews/${id ? `${id}/` : ''}`
  };
};

export const deleteEmployeeReviewRecord = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-reviews/${id}/`
  };
};

export const downloadStaffAdditionalDocumentAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `staff-additional-documents/${id}/download_file/`
  };
};

export const sendAdditionalDocument = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'staff-additional-documents/'
  };
};

export const updateAdditionalDocumentAction = (body, id) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `staff-additional-documents/${id}/`
  };
};

export const deleteAdditionalDocumentAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `staff-additional-documents/${id}/`
  };
};

export const markNewDocumentsAsRead = id => {
  const state = store.getState();

  return {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-applications/${id}/staff_mark_new_documents_as_read/`
  };
};

export const staffUpdatePhotoAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PUT',
    body,
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employee-applications/${id}/staff_update_photo/`
  };
};

export const sendApplicationMail = (id, body = {}) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `employee-applications/${id}/send_mail/`
  };
};

export const updateRecruitmentNewsBaner = body => {
  const state = store.getState();

  return {
    method: 'POST',
    body,
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'companies/update_recruitment_news_baner/'
  };
};

export const getRecruitmentNewsBaner = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    endpoint: 'companies/get_recruitment_news_baner/'
  };
};

export const getManagerApplicationsAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'employees/get_manager_applications/'
  };
};

export const getManagerPeriodsAction = (
  onlyPeriods = false,
  applicationId = null
) => {
  const state = store.getState();
  let params = `?onlyPeriods=${onlyPeriods}`;
  if (applicationId) {
    params += `&applicationId=${applicationId}`;
  }

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employees/get_manager_periods/${params}`
  };
};

export const getEmployeesByPeriodAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    body,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'employees/get_employees_by_period/'
  };
};

export const getAllPeriodsAction = () => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employees/get_all_periods/?seasonYear=${state.app.seasonYear}`
  };
};

export const uploadCheckboxSectionFileAction = (body, id) => {
  const state = store.getState();

  return {
    method: 'POST',
    body,
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `checkbox-section/${id}/upload_file/`
  };
};

export const downloadCheckboxSectionFileAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `checkbox-section/${id}/download_file/`
  };
};

export const submitCheckboxSectionAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'checkbox-section/'
  };
};

export const getEmployeesAccountsAction = (
  method = 'GET',
  id = null,
  val = null,
  filtersParams = null
) => {
  const state = store.getState();
  const search = _.isNil(val) || val.length === 0 ? '' : `?search=${val}`;
  const filter = _.isNil(filtersParams)
    ? ''
    : _.isNil(val) || val.length === 0
      ? `?${filtersParams}`
      : `&${filtersParams}`;
  const params = `${search}${filter}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `employees-accounts/${id ? `${id}/` : `${params}`}`
  };
};

export const updateEmployeeAccountsConfigAction = (body, id) => {
  const state = store.getState();

  return {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `employee-configs/${id}/`
  };
};

export const submitEmployeeAccount = (id, body) => {
  const state = store.getState();
  const isFormData = body instanceof FormData;

  return {
    method: id ? 'PUT' : 'POST',
    headers: isFormData
      ? { Authorization: `Bearer ${state.app.token}` }
      : {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${state.app.token}`
      },
    body,
    endpoint: `employees-accounts/${id ? `${id}/` : ''}`
  };
};

export const getReviewReport = body => {
  const state = store.getState();
  const season = state.app.season;

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    responseType: 'blob',
    endpoint: `employees/reviews_report/?season_id=${season}`
  };
};

export const sendEmployeeMail = (id, body = {}) => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: `employees/${id}/send_mail/`
  };
};

export const getOrganizationalDocumentSections = body => {
  const state = store.getState();

  return {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    body,
    endpoint: 'organizational-document-sections/get_period_sections/'
  };
};

export const downloadOrganizationalDocumentFileAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `organizational-document-sections/${id}/download_file/`
  };
};

export const updateOrganizationalDocumentSectionAction = (body, id) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    body,
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `organizational-document-sections/${id}/`
  };
};

export const createOrganizationalDocumentSectionAction = (body, id) => {
  const state = store.getState();

  return {
    method: 'POST',
    body,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'organizational-document-sections/create_new_section/'
  };
};

export const createOrganizationalDocumentSubSectionAction = body => {
  const state = store.getState();

  return {
    method: 'POST',
    body,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: 'organizational-document-sub-sections/create_new_section/'
  };
};

export const deleteOrganizationalDocumentSubSectionAction = id => {
  const state = store.getState();

  return {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `organizational-document-sub-sections/${id}/`
  };
};

export const destroyOrganizationalDocumentSectionFileAction = id => {
  const state = store.getState();

  return {
    method: 'POST',
    body: {},
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `organizational-document-sections/${id}/destroy_file/`
  };
};

export const updateOrganizationalDocumentSubSectionAction = (body, id) => {
  const state = store.getState();

  return {
    method: 'PATCH',
    body,
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `organizational-document-sub-sections/${id}/`
  };
};

export const destroyOrganizationalDocumentSubSectionFileAction = id => {
  const state = store.getState();

  return {
    method: 'POST',
    body: {},
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `organizational-document-sub-sections/${id}/destroy_file/`
  };
};

export const downloadOrganizationalDocumentSubFileAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `organizational-document-sub-sections/${id}/download_file/`
  };
};

export const getSaleCalendarDataAction = (resortName, filters = {}) => {
  const state = store.getState();
  const { token, season, module } = state.app;

  const params = new URLSearchParams({
    resort_name: resortName,
    season_id: season,
    module_identifier: module,
    filters: JSON.stringify(filters)
  });

  return {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    },
    endpoint: `sale-calendar/get_sale_calendar_data/?${params.toString()}`
  };
};

export const submitSaleCalendarDataAction = (id, body) => {
  const state = store.getState();

  return {
    method: 'PUT',
    body,
    headers: {
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `sale-calendar/${id}/save_sale_calendar_data/`
  };
};

export const getSaleCalendarReportAction = (id, startDate, endDate) => {
  const state = store.getState();
  const { token, season, module } = state.app;

  const params = new URLSearchParams({
    season_id: season,
    module_identifier: module,
    start_date: startDate,
    end_date: endDate
  });

  return {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    },
    responseType: 'blob',
    endpoint: `sale-calendar/${id}/export_sale_calendar_report/?${params.toString()}`
  };
};
export const getPackagesAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `packages/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitPackageAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;
  body.season = state.app.season;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `packages/${id ? `${id}/` : ''}`
  };
};

// export const changeDocumentsSigningDates = body => {
//   const state = store.getState();
//   console.log('reqbody', body);

//   return {
//     body,
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       Authorization: `Bearer ${state.app.token}`
//     },
//     endpoint: 'orders/change_documents_signing_dates/'
//   };
// };

export const changeDocumentsSigningDates = ({
  order_ids,
  documents,
  only_extend,
  remove_signiature
}) => {
  const state = store.getState(); // pobieramy token

  return {
    method: 'POST',
    endpoint: 'orders/change_documents_signing_dates/',
    body: { order_ids, documents, only_extend, remove_signiature },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    }
  };
};

export const getSharedAccommodationInfoForClient = id => {
  const state = store.getState();

  const headers = { 'Content-Type': 'application/json' };

  if (state.app.token !== null) {
    headers.Authorization = `Bearer ${state.app.token}`;
  }

  return {
    method: 'GET',
    headers,
    endpoint: `orders/${id}/get_shared_accommodation_info_for_client/`
  };
};

export const getSunActiveCategoryAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&search=${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `sunactive_categories/?season=${state.app.season}${search}`
  };
};

export const submitSunActiveCategoryAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `sunactive_categories/${id ? `${id}/` : ''}`
  };
};

export const getAvailabilityStatusesAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `availability-statuses/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitAvailabilityStatusAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `availability-statuses/${id ? `${id}/` : ''}`
  };
};

export const getTfgFeedsAction = (
  method = 'GET',
  id = null,
  val = null,
  filtersParams = null
) => {
  const state = store.getState();

  const search = _.isNil(val) || val.length === 0
    ? ''
    : `?search=${val}`;

  const filter = _.isNil(filtersParams)
    ? ''
    : _.isNil(val) || val.length === 0
      ? `?${filtersParams}`
      : `&${filtersParams}`;

  const moduleFilter = state.app.module
    ? `${search || filter ? '&' : '?'}module_identifier=${state.app.module}`
    : '';

  const seasonFilter = state.app.season
    ? `${search || filter || moduleFilter ? '&' : '?'}season=${state.app.season}`
    : '';

  const params = `${search}${filter}${moduleFilter}${seasonFilter}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `tfg-feeds/${id ? `${id}/` : params}`
  };
};


export const retryTfgFeedAction = (body, method, id) => {
  const state = store.getState();
  body.module = state.app.module;

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `tfg-feeds/${id}`
  };
};

export const downloadFeedCSVAction = id => {
  const state = store.getState();

  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    responseType: 'blob',
    endpoint: `tfg-feeds/${id}/download_csv/`
  };
};


export const getActivityCategoriesAction = (val, method) => {
  const state = store.getState();
  const search = _.isNil(val) ? '' : `&${val}`;

  return {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `activity-categories/?season=${state.app.season}&module=${state.app.module}${search}`
  };
};

export const submitActivityCategoryAction = (body, method, id) => {
  const state = store.getState();

  return {
    body,
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${state.app.token}`
    },
    endpoint: `activity-categories/${id ? `${id}/` : ''}`
  };
};

export const clientQualificationCardAction = (orderId, action, secretKey, annexNr) => ({
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    'x-requested-with': secretKey
  },
  responseType: 'blob',
  endpoint: `handle-qualification-card-anonymous/${orderId}/?action=${action}&annex_nr=${annexNr}`
});

export const clientAgreementAction = (orderId, action, secretKey, annexNr) => ({
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    'x-requested-with': secretKey
  },
  responseType: 'blob',
  endpoint: `handle-agreement-anonymous/${orderId}/?action=${action}&annex_nr=${annexNr}`
});
